import { StockQuantity } from './StockQuantity';
import classes from './StockTotal.module.css';

interface IProps {
    total: number;
}

/** The sum over all stock rows of a Lagerort. */
// @ai-generated 2026-10-23T14:40:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function StockTotal({ total }: IProps) {
    return (
        <span className={classes.total}>
            <span>Gesamt</span>
            <StockQuantity value={total} />
            <span>t</span>
        </span>
    );
}
